<template>
    <v-card>
        <div class="pa-4">
            <div class="d-flex">
                <h4>Filter</h4>
                <!-- <v-btn class="ml-auto" @click="filter = true" icon outlined tile small
          ><i class="fa fa-filter"></i
        ></v-btn> -->
            </div>
        </div>
        <v-divider></v-divider>
        <div
            v-if="searchLoading"
            class="d-flex align-items-center justify-center py-5"
        >
            <v-progress-circular indeterminate />
        </div>
        <div v-else>
            <div class="pa-4">
                <v-row>
                    <v-col md="4" cols="12">
                        <v-text-field
                            outlined
                            flat
                            label="Name"
                            v-model="searchData.name"
                            hide-details=""
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="4" cols="12">
                        <v-text-field
                            outlined
                            flat
                            label="Username"
                            hide-details=""
                            v-model="searchData.username"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="4" cols="12">
                        <v-autocomplete
                            :items="[
                                'United States',
                                'United Kingdom',
                                'Canada',
                                'South America',
                                'Africa',
                                'Australia',
                                'International',
                            ]"
                            outlined
                            dense
                            hide-details=""
                            v-model="searchData.country"
                            clearable
                            label="Country"
                        ></v-autocomplete>
                    </v-col>
                    <v-col md="4" cols="12">
                        <vue-google-autocomplete
                            id="map"
                            ref="ref_city"
                            class="custom-component mb-0"
                            placeholder="City"
                            v-on:placechanged="getAddressData"
                        >
                        </vue-google-autocomplete>
                    </v-col>
                    <v-col md="4" cols="12">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="searchData.creating_since"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="searchData.creating_since"
                                    label="Creating Since"
                                    readonly
                                    outlined
                                    clearable
                                    hide-details=""
                                    dense
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules="[myrules.arrayRequired]"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="searchData.creating_since"
                                type="month"
                                no-title
                                scrollable
                            >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="
                                        $refs.menu.save(
                                            searchData.creating_since
                                        )
                                    "
                                >
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col md="4" cols="12">
                        <v-autocomplete
                            :items="skills"
                            item-text="name"
                            item-value="name"
                            outlined
                            dense
                            hide-details=""
                            v-model="searchData.skill"
                            clearable
                            label="Skill"
                        ></v-autocomplete>
                    </v-col>
                    <v-col md="4" cols="12">
                        <v-autocomplete
                            :items="creator_type"
                            outlined
                            dense
                            hide-details=""
                            v-model="searchData.creator_type"
                            clearable
                            label="Creator Type"
                        ></v-autocomplete>
                    </v-col>
                    <v-col md="4" cols="12">
                        <v-select
                            outlined
                            flat
                            :items="getGenre()"
                            label="Genre"
                            hide-details=""
                            clearable
                            v-model="searchData.genre"
                            dense
                        >
                        </v-select>
                    </v-col>
                    <v-col md="4" cols="12">
                        <v-select
                            outlined
                            flat
                            :items="getGenre()"
                            label="Sub Genre"
                            v-model="searchData.sub_genre"
                            hide-details=""
                            clearable
                            dense
                        >
                        </v-select>
                    </v-col>
                    <v-col md="6" cols="12">
                        <v-btn
                            @click="clearFilter"
                            block
                            color="red white--text"
                            >Clear</v-btn
                        >
                    </v-col>
                </v-row>
            </div>
            <v-tabs v-model="tab">
                <v-tab> Users </v-tab>
                <v-tab> Groups </v-tab>
                <v-tab> Events </v-tab>
                <v-tab> Featured Users </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-container>
                        <v-row>
                            <v-col
                                md="4"
                                cols="12"
                                v-for="(user, k) of lc_getSearchedUsers()"
                                :key="'UserSearchCard' + k"
                            >
                                <UserCard :user="user" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container>
                        <v-row>
                            <v-col
                                v-for="g of lc_getSearchedGroups()"
                                :key="g.id"
                                md="4"
                                cols="12"
                            >
                                <GroupCard
                                    :item="g"
                                    :search="
                                        () => resetGroupsSearch(searchQuery)
                                    "
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container>
                        <v-row>
                            <v-col
                                v-for="(event, k) of lc_getSearchedEvents()"
                                :key="k"
                                md="4"
                                cols="12"
                            >
                                <event-card :event="event" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container>
                        <v-row>
                            <v-col
                                v-for="(user,
                                k) of lc_getSearchedFeaturedUsers()"
                                :key="k"
                                md="6"
                                cols="12"
                            >
                                <div class="border">
                                    <div class="d-flex align-center">
                                        <div
                                            class="d-inline-block avatar-wrapper"
                                        >
                                            <v-avatar
                                                class="mr-2"
                                                v-if="user.profile_image"
                                                size="42"
                                                ><img :src="user.profile_image"
                                            /></v-avatar>
                                            <v-avatar
                                                class="mr-2"
                                                v-else
                                                size="42"
                                                ><img
                                                    src="/images/default-profile.jpg"
                                            /></v-avatar>
                                            <div class="avatar-icon">
                                                <i class="fa fa-trophy"></i>
                                            </div>
                                        </div>
                                        <h4 class="ma-0">
                                            {{ user.firstname }}
                                            {{ user.lastname }}
                                        </h4>
                                    </div>
                                    <div class="d-flex mt-4">
                                        <b>Creator Type:</b>
                                        <v-chip-group class="ml-auto">
                                            <v-chip
                                                v-for="(type,
                                                k) of user.creator_type"
                                                :key="k"
                                                x-small
                                                :class="{
                                                    'mr-0':
                                                        k ==
                                                        user.creator_type
                                                            .length -
                                                            1,
                                                }"
                                                >{{ type }}</v-chip
                                            >
                                        </v-chip-group>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <b>Country:</b>
                                        <small class="ml-auto">{{
                                            user.country
                                        }}</small>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <b>Experience:</b>
                                        <small class="ml-auto">{{
                                            user.experience
                                        }}</small>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <b>Genre:</b>
                                        <v-chip-group class="ml-auto">
                                            <v-chip
                                                v-for="(genre, k) of user.genre"
                                                :key="k"
                                                x-small
                                                :class="{
                                                    'mr-0':
                                                        k ==
                                                        user.genre.length - 1,
                                                }"
                                                >{{ genre }}</v-chip
                                            >
                                        </v-chip-group>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <b>Weekly Challenge Winner:</b>
                                        <small class="ml-auto">{{
                                            user.title
                                        }}</small>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
            </v-tabs-items>
        </div>
        <v-dialog v-model="filter" width="500">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Filter</v-toolbar-title>
                </v-toolbar>
                <div class="pa-4">
                    <v-text-field
                        outlined
                        flat
                        label="Name"
                        hide-details=""
                        dense
                    ></v-text-field>
                    <v-text-field
                        outlined
                        flat
                        label="Username"
                        class="mt-5"
                        hide-details=""
                        dense
                    ></v-text-field>
                    <v-text-field
                        outlined
                        flat
                        label="Country"
                        class="mt-5"
                        hide-details=""
                        dense
                    ></v-text-field>
                    <v-select
                        outlined
                        flat
                        class="mt-5"
                        label="Creator Type"
                        hide-details=""
                        dense
                    >
                    </v-select>
                    <v-select
                        outlined
                        flat
                        class="mt-5"
                        :items="getGenre()"
                        label="Genre"
                        hide-details=""
                        dense
                    >
                    </v-select>
                    <v-select
                        outlined
                        flat
                        class="mt-5"
                        :items="getGenre()"
                        label="Sub Genre"
                        hide-details=""
                        dense
                    >
                    </v-select>
                    <div class="d-flex mt-5">
                        <v-btn
                            class="ml-auto mr-3"
                            @click="clearFilter"
                            color="red white--text"
                            >Clear</v-btn
                        >
                        <v-btn color="primary" @click="filter = false"
                            >Apply</v-btn
                        >
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import UserCard from "../components/network/UserCard.vue";
import GroupCard from "../components/network/GroupCard.vue";
import EventCard from "../components/EventCard.vue";
import { mapGetters } from "vuex";
import FeaturedUsers from "../components/ProfileUserCard.vue";
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
    name: "Network",
    components: {
        UserCard,
        GroupCard,
        EventCard,
        FeaturedUsers,
        VueGoogleAutocomplete,
    },
    data() {
        return {
            tab: null,
            filter: false,
            update: false,
            skills: [
                { header: "Instruments" },
                { name: "Accordion", group: "Instruments" },
                { name: "Acoustic Guitar", group: "Instruments" },
                { name: "Bagpipes", group: "Instruments" },
                { name: "Banjo", group: "Instruments" },
                { name: "Bass Guitar", group: "Instruments" },
                { name: "Beatbox", group: "Instruments" },
                { name: "Bugle", group: "Instruments" },
                { name: "Cello", group: "Instruments" },
                { name: "Clarinet", group: "Instruments" },
                { name: "Cymbals", group: "Instruments" },
                { name: "Drums", group: "Instruments" },
                { name: "Electric Guitar", group: "Instruments" },
                { name: "Flute", group: "Instruments" },
                { name: "French Horn", group: "Instruments" },
                { name: "Harmonica", group: "Instruments" },
                { name: "Harp", group: "Instruments" },
                { name: "Keyboard", group: "Instruments" },
                { name: "Midi", group: "Instruments" },
                { name: "Organ", group: "Instruments" },
                { name: "Piano", group: "Instruments" },
                { name: "Recorder", group: "Instruments" },
                { name: "Saxophone", group: "Instruments" },
                { name: "Tambourine", group: "Instruments" },
                { name: "Triangle", group: "Instruments" },
                { name: "Trumpet", group: "Instruments" },
                { name: "Tuba", group: "Instruments" },
                { name: "Ukelele", group: "Instruments" },
                { name: "Voice", group: "Instruments" },
                { name: "Viola", group: "Instruments" },
                { name: "Violin", group: "Instruments" },
                { name: "Xylophone", group: "Instruments" },
                { divider: true },
                { header: "Composition" },
                { name: "Lyrics", group: "Composition" },
                { name: "Melody", group: "Composition" },
                { name: "Arrangement", group: "Composition" },
                { name: "Score", group: "Composition" },
                { name: "Vocal Production", group: "Composition" },
                { divider: true },
                { header: "Production" },
                { name: "Ableton", group: "Production" },
                { name: "Acid", group: "Production" },
                { name: "Cubase", group: "Production" },
                { name: "Fruity Loops", group: "Production" },
                { name: "GarageBand", group: "Production" },
                { name: "Logic Pro", group: "Production" },
                { name: "PreSonus", group: "Production" },
                { name: "Protools", group: "Production" },
                { name: "Reason", group: "Production" },
                { name: "Reaper", group: "Production" },
                { name: "StudioOne", group: "Production" },
            ],
            creator_type: [
                "Writer",
                "Song Writer",
                "Producer",
                "Composer",
                "Artist",
            ],
            searchData: {
                name: "",
                username: "",
                country: null,
                skill: null,
                creator_type: null,
                city: null,
                creating_since: null,
                genre: null,
                sub_genre: null,
            },
        };
    },
    methods: {
        ...mapGetters(["getGenre"]),
        getAddressData: function(addressData, placeResultData, id) {
            this.searchData.city = addressData.administrative_area_level_2;
        },
        lc_getSearchedUsers() {
            let temp = [];
            if (this.searchedUsers) {
                temp = JSON.parse(JSON.stringify(this.searchedUsers));

                if (this.searchData.name != "") {
                    temp = temp.filter((t) => {
                        let name = t.firstname + " " + t.lastname;
                        if (!name) return false;
                        return name
                            .toLowerCase()
                            .includes(this.searchData.name.toLowerCase());
                    });
                }
                if (this.searchData.username != "") {
                    temp = temp.filter((t) => {
                        if (!t.username) return false;
                        return t.username
                            .toLowerCase()
                            .includes(this.searchData.username.toLowerCase());
                    });
                }
                if (this.searchData.country != null) {
                    temp = temp.filter((t) => {
                        if (!t.country) return false;
                        return t.country
                            .toLowerCase()
                            .includes(this.searchData.country.toLowerCase());
                    });
                }
                if (
                    !(
                        this.searchData.city == null ||
                        this.searchData.city == "" ||
                        this.searchData.city == undefined
                    )
                ) {
                    temp = temp.filter((t) => {
                        console.log(this.searchData.city);
                        if (!t.city) return false;
                        return (
                            t.city.toLowerCase() ==
                            this.searchData.city.toLowerCase()
                        );
                    });
                }
                if (this.searchData.creating_since != null) {
                    temp = temp.filter((t) => {
                        console.log(t.creating_since);
                        if (!t.creating_since) return false;
                        return (
                            t.creating_since.toLowerCase() ==
                            this.searchData.creating_since.toLowerCase()
                        );
                    });
                }
                if (this.searchData.skill != null) {
                    console.log("skill");
                    temp = temp.filter((t) => {
                        console.log(t.skills);
                        if (!t.skills || t.skills.length == 0) return false;
                        return t.skills.includes(this.searchData.skill);
                    });
                }
                if (this.searchData.creator_type != null) {
                    temp = temp.filter((t) => {
                        if (!t.creator_type) return false;
                        return t.creator_type.includes(
                            this.searchData.creator_type
                        );
                    });
                }
                if (this.searchData.genre != null) {
                    temp = temp.filter((t) => {
                        if (!t.genre) return false;
                        return t.genre.includes(this.searchData.genre);
                    });
                }
                if (this.searchData.sub_genre != null) {
                    temp = temp.filter((t) => {
                        if (!t.sub_genre) return false;
                        return t.sub_genre.includes(this.searchData.sub_genre);
                    });
                }
            }
            return temp;
        },
        lc_getSearchedGroups() {
            let temp = [];
            if (this.searchedGroups) {
                temp = JSON.parse(JSON.stringify(this.searchedGroups));

                if (this.searchData.name != "") {
                    temp = temp.filter((t) => {
                        let name = t.name;
                        if (!name) return false;
                        return name
                            .toLowerCase()
                            .includes(this.searchData.name.toLowerCase());
                    });
                }
            }
            return temp;
        },
        lc_getSearchedEvents() {
            let temp = [];
            if (this.searchedEvents) {
                temp = JSON.parse(JSON.stringify(this.searchedEvents));
                if (this.searchData.name != "") {
                    temp = temp.filter((t) => {
                        let name = t.title;
                        if (!name) return false;
                        return name
                            .toLowerCase()
                            .includes(this.searchData.name.toLowerCase());
                    });
                }
            }
            return temp;
        },
        async lc_getSearchedFeaturedUsers() {
            console.table(this.searchData);
            let temp = [];
            if (this.searchedFeaturedUsers) {
                temp = await JSON.parse(
                    JSON.stringify(this.searchedFeaturedUsers)
                );
                console.log(this.searchedFeaturedUsers);

                if (this.searchData.name != "") {
                    temp = temp.filter((t) => {
                        let name = t.firstname + " " + t.lastname;
                        if (!name) return false;
                        return name
                            .toLowerCase()
                            .includes(this.searchData.name.toLowerCase());
                    });
                }
                if (this.searchData.username != "") {
                    temp = temp.filter((t) => {
                        if (!t.username) return false;
                        return t.username
                            .toLowerCase()
                            .includes(this.searchData.username.toLowerCase());
                    });
                }
                if (this.searchData.country != null) {
                    temp = temp.filter((t) => {
                        if (!t.country) return false;
                        return t.country
                            .toLowerCase()
                            .includes(this.searchData.country.toLowerCase());
                    });
                }
                if (this.searchData.city != null) {
                    temp = temp.filter((t) => {
                        console.log(t.city);
                        if (!t.city) return false;
                        return (
                            t.city.toLowerCase() ==
                            this.searchData.city.toLowerCase()
                        );
                    });
                }
                if (this.searchData.creating_since != null) {
                    temp = temp.filter((t) => {
                        console.log(t.creating_since);
                        if (!t.creating_since) return false;
                        return (
                            t.creating_since.toLowerCase() ==
                            this.searchData.creating_since.toLowerCase()
                        );
                    });
                }
                if (this.searchData.skill != null) {
                    console.log("skill");
                    temp = temp.filter((t) => {
                        console.log(t.skills);
                        if (!t.skills || t.skills.length == 0) return false;
                        return t.skills
                            .toLowerCase()
                            .includes(this.searchData.skill.toLowerCase());
                    });
                }
                if (this.searchData.creator_type != null) {
                    temp = temp.filter((t) => {
                        if (!t.creator_type) return false;
                        return t.creator_type.includes(
                            this.searchData.creator_type
                        );
                    });
                }
                if (this.searchData.genre != null) {
                    temp = temp.filter((t) => {
                        if (!t.genre) return false;
                        return t.genre.includes(this.searchData.genre);
                    });
                }
                if (this.searchData.sub_genre != null) {
                    temp = temp.filter((t) => {
                        if (!t.sub_genre) return false;
                        return t.sub_genre.includes(this.searchData.sub_genre);
                    });
                }
            }
            console.log(temp);
            return temp;
        },
        applyFilter() {},
        clearFilter() {
            this.$refs.ref_city.clear();
            this.searchData = {
                name: "",
                username: "",
                country: null,
                skill: null,
                creator_type: null,
                city: null,
                creating_since: null,
                genre: null,
                sub_genre: null,
            };
        },
    },
    watch: {
        searchedGroups() {
            this.update = !this.update;
        },
    },
    mounted() {},
};
</script>

<style scoped>
.bordered {
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 10px;
    border-radius: 8px;
}
.border {
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 10px;
    border-radius: 6px;
}
.avatar-wrapper {
    position: relative;
}
.avatar-icon {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    color: #ffffff;
    width: 22.5px;
    height: 22.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: green;
    font-size: 12px;
    border: 0 !important;
}
</style>
